import React from 'react'

import SettingsIcon from 'Assets/Images/icons/settings'
import { PATHS } from 'Config/Routing/paths'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

export const BreadcrumbsUrlShortener = ({ className }) => {
  return (
    <div className={className}>
      <StyledBreadcrumbs
        icon={<SettingsIcon style={{ width: 20 }} />}
        breadcrumbs={[
          {
            label: 'Settings',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
          },
          { label: 'Url Shortener' },
        ]}
      />
    </div>
  )
}
